<template>
   <vue-final-modal
      v-model="v310Modal" 
      classes="modal-container"
      content-class="v310-modal-content"
      :drag="true"
      drag-selector=".drug-area"
      @opened="opened()"
      @click-outside="$emit('cancel')"
      >
      <div class="drug-area">
      <button 
         id="first"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Voucher <i class="fs-14">(Resol. SSS 310/04)</i></span>
      </div>
      <div class="up-voucher p-0 mt-1">
         <div class="container">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last').focus()"></div>
            
            <voucher-310-pdf :pdfData="v310Object" />
               
            <!--
            <pre>{{ v310Object }}</pre>
            -->
         </div>
      </div>
            <div class="row p-0 justify-content-between mx-0">
               <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
               <div class="d-flex justify-content-end pt-2 px-0 col-10">
                  <button type="button" 
                        :tabindex="tabIndexNumber(3)" 
                        class="btn btn-outline-light btn-sm me-1"
                        @click="generatePDF()"
                        >
                     Descargar
                  </button>
                  <button type="button" 
                        id="last"
                        :tabindex="tabIndexNumber(4)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('cancel')"
                        >
                     Salir
                  </button>
                  <div :tabindex="tabIndexNumber(5)" onfocus="document.getElementById('first').focus()"></div>
               </div>
            </div>
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed } from 'vue';
import { useStore } from 'vuex'
import html2pdf from 'html2pdf.js';

import WspService from '../../workSpace/workSpace.service';

import UserCircle from '../../../components/UserCircle.vue';
import Voucher310Pdf from './Voucher310Pdf.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      Voucher310Pdf
   },

   props: {
      v310Object: Object
   },

   emits: [ 'cancel' ],

   setup( props ) {

      const initialTabIndex = ref(100)
      const v310Modal = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      function opened() {
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            console.log(response.data)
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      async function generatePDF() {
         //
         let result = await createPDF()
         const blob = new Blob([result], { type: 'application/pdf' })
         //let file = new File([blob], 'pepitito.pdf',  { type: 'application/pdf' })
         //let file = new File([blob], String( 'voucher310' ) + '.pdf',  { type: 'application/pdf' })
         let file = new File([blob], 
            'V310-' + props.v310Object.id + '-' + props.v310Object.cuil + '.pdf',
            { type: 'application/pdf' })
         // Create a download link for the resulting PDF Blob and trigger the download
         const downloadLink = document.createElement('a');
         downloadLink.href = URL.createObjectURL(file);
         downloadLink.download = file.name;
         downloadLink.onclick = () => downloadLink.remove();
         document.body.appendChild(downloadLink);
         downloadLink.click();
         //         
      }

      function createPDF() {
         return new Promise( (resolve, reject) => {
            console.log('create PDF function executed!');
            let element = document.getElementById('element-to-print');

            let opt = {
               margin: 10,
               enableLinks: false,
               image: {type: 'jpeg', quality: 0.95},
               html2canvas: {scale: 2, useCORS: true}
               //jsPDF: {format: 'a4', orientation: 'portrait'}
            };

            try {
                const blob = html2pdf().set(opt).from(element).outputPdf('blob');
                resolve(blob);
            } catch (e) {
                reject(e);
            }
         });
      }
      
      return {
         generatePDF,
         myCircle,
         opened,
         tabIndexNumber,
         v310Modal,
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.v310-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.up-voucher {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
</style>
